module.exports = __webpack_public_path__ + "d55aff1e5f2356ae7ab01389d040d299.MP3";